import { useEffect } from 'react'

export const useClickOutside = (
  ref: React.RefObject<HTMLDivElement>,
  setIsOpen: (isOpen: boolean) => void
) => {
  const handleClickOutside = (event: MouseEvent) => {
    if (ref.current && !ref.current.contains(event.target as Node)) {
      setIsOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])
}
